<template>
  <el-dialog
    title="新增店铺"
    :visible.sync="dialogVisible"
    width="500px"
    @closed="handleResetForm"
    :close-on-click-modal="false"
    :destroy-on-close="false"
  >
    <el-form ref="form" :model="form" label-width="100px">
      <el-form-item label="选择企业">
        <!-- 远程搜索选择框 -->
        <el-select
          v-model="form.shopId"
          placeholder="搜索企业名称"
          filterable
          remote
          :remote-method="queryEnterprise"
          :loading="loading"
          style="width: 350px"
        >
          <el-option
            v-for="item in enterpriseList"
            :key="item.id"
            :label="`${item.shopName}/${item.userName}/${item.shopTypeName}/${item.provinceName}${item.cityName}${item.areaName}${item.address}`"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { searchDrugStoreByName } from "@/api/saleRule/agent";
export default {
  name: "ShopAddDialog",
  data() {
    return {
      dialogVisible: false,
      form: {
        shopId: "",
      },
      enterpriseList: [],
      loading: false,
    };
  },
  methods: {
    publicOpen() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleResetForm() {
      this.form.shopId = "";
      this.enterpriseList = [];
    },
    handleSubmit() {
      this.$emit("submit", this.form);
      this.dialogVisible = false;
    },
    queryEnterprise(query) {
      this.loading = true;
      //   if (!query) {
      //     return;
      //   }
      searchDrugStoreByName({
        name: query,
      })
        .then((res) => {
          if (res) {
            this.enterpriseList = res;
          } else {
            this.enterpriseList = [];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped lang="scss"></style>
